export const REPURPOSE_SUPPORTED_VIEW_NAMES = ['previewH264', 'previewMp3'];

export const REPURPOSE_SUPPORTED_FILE_FORMAT_FAMILIES = ['image'];
